if (!customElements.get('product-recommendations')) {
  class RecommendProducts extends HTMLElement {
    constructor() {
      super();

      this.bindEvents();
    }

    bindEvents() {
      this.loadHtml();
    }

    async loadHtml() {
      const url = this.dataset.url;
      if (!url) return;

      await fetch(url, { method: 'GET' })
        .then((response) => response.text())
        .then((html) => {
          let fetchedHtml = this.getSectionDOM(html, '.js-product-recommendations');

          if (this.parentElement.classList.contains('js-basket-recommendations'))
            fetchedHtml = this.updateCarouselInBasketDrawer(fetchedHtml);

          this.innerHTML = fetchedHtml.innerHTML;
          updateLazyLoad?.();
        })
        .catch((err) => {
          this.closest('.js-recommendations')?.classList.add('hidden');
        })
        .finally(() => {
          // const quickView = document.querySelector("product-quickview");
          // if (!quickView) return;
          // quickView.bindEvents();
        });
    }

    updateCarouselInBasketDrawer(html) {
      const basketCarousel = this.parentElement;
      html.querySelector('.js-swiper-carousel').dataset.colDesk = basketCarousel.dataset.colDesk;

      return html;
    }

    getSectionDOM(html, selector = '.js-recommendations-content') {
      const dom = new DOMParser().parseFromString(html, 'text/html');
      if (selector) return dom.querySelector(selector);
      return dom;
    }
  }

  customElements.define('product-recommendations', RecommendProducts);
}
